module.exports = __webpack_public_path__ + "static/altana-jesien-wypoczynek_thumb-5e6ed182244a2fa61faf4c6bb7770e67.jpg";